import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

type LegalLayoutProps = {
  title: string;
  updated: string;
  children: React.ReactNode;
};

/**
 * Public (no-auth) chrome for the legal pages (Impressum, Datenschutz).
 * Must stay reachable without login — § 5 DDG requires the Impressum to be
 * directly accessible, and Art. 13 DSGVO the privacy notice.
 */
export default function LegalLayout({ title, updated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-cream text-ink">
      <div className="mx-auto w-full max-w-[720px] px-5 py-10 sm:py-14">
        <header className="mb-8">
          <Link to="/login" className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-ink-soft hover:text-ink transition-colors no-underline">
            <ArrowLeft className="h-3.5 w-3.5" />
            Zurück zur Anmeldung
          </Link>
          <div className="mt-6 flex items-center gap-3">
            <img src="/logo-always-on-stock.png" alt="Always On Stock" className="h-10 w-auto" />
          </div>
          <h1 className="mt-6 text-[24px] font-extrabold tracking-tight text-ink">{title}</h1>
          <p className="mt-1 text-[12.5px] text-ink-soft">Stand: {updated}</p>
        </header>

        <article className="text-ink-muted [&_h2]:mt-9 [&_h2]:mb-3 [&_h2]:text-[15px] [&_h2]:font-bold [&_h2]:text-ink [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-[13.5px] [&_h3]:font-bold [&_h3]:text-ink [&_p]:mb-3 [&_p]:text-[13.5px] [&_p]:leading-[1.7] [&_ul]:mb-4 [&_ul]:mt-1 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1.5 [&_li]:text-[13.5px] [&_li]:leading-[1.6] [&_a]:text-brand-deep [&_a]:font-medium [&_a]:underline [&_strong]:text-ink [&_strong]:font-semibold [&_address]:not-italic">
          {children}
        </article>

        <footer className="mt-12 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-line pt-6 text-[12.5px]">
          <Link to="/impressum" className="font-medium text-ink-soft hover:text-ink transition-colors no-underline">Impressum</Link>
          <Link to="/datenschutz" className="font-medium text-ink-soft hover:text-ink transition-colors no-underline">Datenschutz</Link>
          <Link to="/login" className="font-medium text-ink-soft hover:text-ink transition-colors no-underline">Anmeldung</Link>
        </footer>
      </div>
    </div>
  );
}
